const Eye = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z"
        fill="#8646F2"
      />
      <path
        d="M21.5 23C24.5376 23 27 19.866 27 16C27 12.134 24.5376 9 21.5 9C18.4624 9 16 12.134 16 16C16 19.866 18.4624 23 21.5 23Z"
        fill="white"
      />
      <path
        d="M10.5 23C13.5376 23 16 19.866 16 16C16 12.134 13.5376 9 10.5 9C7.46243 9 5 12.134 5 16C5 19.866 7.46243 23 10.5 23Z"
        fill="white"
      />
      <path
        d="M24 20C25.6569 20 27 18.2091 27 16C27 13.7909 25.6569 12 24 12C22.3431 12 21 13.7909 21 16C21 18.2091 22.3431 20 24 20Z"
        fill="#212121"
      />
      <path
        d="M13 20C14.6569 20 16 18.2091 16 16C16 13.7909 14.6569 12 13 12C11.3431 12 10 13.7909 10 16C10 18.2091 11.3431 20 13 20Z"
        fill="#212121"
      />
      <path
        d="M25.5 16.333C26.3284 16.333 27 15.6614 27 14.833C27 14.0046 26.3284 13.333 25.5 13.333C24.6716 13.333 24 14.0046 24 14.833C24 15.6614 24.6716 16.333 25.5 16.333Z"
        fill="white"
      />
      <path
        d="M14.5 16.333C15.3284 16.333 16 15.6614 16 14.833C16 14.0046 15.3284 13.333 14.5 13.333C13.6716 13.333 13 14.0046 13 14.833C13 15.6614 13.6716 16.333 14.5 16.333Z"
        fill="white"
      />
    </svg>
  );
};

export default Eye;
